import React, { useEffect, useState } from 'react';
import Dashboard from './SideBar';
import { useAuth } from '../contexts/authContext';
import {useDarkMode} from "../contexts/darkModeContext";
import {Button, Dialog, DialogBackdrop, DialogPanel, DialogTitle, Input, Select} from "@headlessui/react";
import {PlusCircleIcon, RectangleGroupIcon} from "@heroicons/react/24/outline";
import {db} from "../firebase/firebase";
import {PlusIcon} from "@heroicons/react/16/solid";
import CourseExpanded from "./Course/CourseExpanded";
import Loading from "./Loading";


const CourseInfo = () => {
    const { currentUser } = useAuth();

    const { darkMode } = useDarkMode();

    const [updating, setUpdating] = useState(false);

    const localStorageKey = 'metric';

    const [metric] = useState(() => {
        const storedSettings = localStorage.getItem(localStorageKey);
        return storedSettings ? JSON.parse(storedSettings).metric : false;
    });

    useEffect(() => {
        localStorage.setItem(
            localStorageKey,
            JSON.stringify({ metric })
        );
        console.log("Changes Saved");
    }, [metric]);


    const [add, setAdd] = useState(false);


    const [courseName, setCourseName] = useState("");
    const [courseSize, setCourseSize] = useState(0);
    const [courseAcreage, setCourseAcreage] = useState(0);

    const [courses, setCourses] = useState([]);

    const handleAddCourse = async () => {
        const collectionRef = db.collection('Users').doc(currentUser.uid).collection('courses');

        if (!courseName || courseSize <= 0 || courseAcreage <= 0) {
            alert("Please fill out all course fields correctly.");
            return;
        }

        const holes = Array.from({ length: courseSize }, (_, i) => ({
            name: `${courseName} ${i + 1}`,
        }));

        const courseData = {
            name: courseName,
            size: courseSize,
            acreage: courseAcreage,
            holes: holes,
            createdAt: new Date(),
        };

        try {
            await collectionRef.add(courseData);
            alert("Course added successfully!");
            setAdd(false);
        } catch (error) {
            console.error("Error adding course:", error);
            alert("There was an error adding the course.");
        }
    };

    useEffect(() => {
        const fetchCourses = async () => {
            if (currentUser) {
                try {
                    const storedCourseData = localStorage.getItem(`courseData_${currentUser.uid}`);
                    if (storedCourseData) {
                        const courseData = JSON.parse(storedCourseData);
                        setCourses(courseData);
                    } else {
                        const coursesCollectionRef = db.collection('Users').doc(currentUser.uid).collection('courses');
                        const snapshot = await coursesCollectionRef.get();

                        if (!snapshot.empty) {
                            const courseData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                            setCourses(courseData);
                            localStorage.setItem(`courseData_${currentUser.uid}`, JSON.stringify(courseData));
                        } else {
                            console.log('No courses found');
                        }
                    }
                } catch (error) {
                    console.error('Error fetching courses:', error);
                }
            }
        };

        fetchCourses();
    }, [currentUser]);

    const onUpdate = async () => {
        setUpdating(true);
        // const startTime = Date.now();

        // Planned
        try {
            const coursesCollectionRef = db.collection('Users').doc(currentUser.uid).collection('courses');
            const snapshot = await coursesCollectionRef.get();

            if (!snapshot.empty) {
                const courseData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setCourses(courseData);
                localStorage.setItem(`courseData_${currentUser.uid}`, JSON.stringify(courseData));
            } else {
                console.log('No courses found');
            }
        } catch (error) {
            console.error('Error fetching course data:', error);
        }

        // const endTime = Date.now();
        // const timeElapsed = (endTime - startTime) /1000;
        setUpdating(false);
    };


    // const [selectedCourse, setSelectedCourse] = useState(() => courses?.[0] || null);
    const [selectedCourse, setSelectedCourse] = useState(null);

    useEffect(() => {
        // In case courses are loaded asynchronously and we want to reset on change
        if (courses?.length && !selectedCourse) {
            setSelectedCourse(courses[0]);
        }
    }, [courses]);

    const handleViewCourse = (course) => {
        setSelectedCourse(course);

        console.log(selectedCourse);
    };


    return (
        <div className={`${darkMode ? "text-white" : "text-black"} flex h-[calc(100dvh-4rem] p-3 w-full`}>
            {/*<Dashboard/>*/}

            {updating && (
                <Loading/>
            )}

            <div className={`rounded-lg border ${darkMode ? 'bg-bgDark border-neutral-700' : 'bg-white'} z-20 w-full grid grid-cols-4 grid-rows-1 animate-fadeIn`}>


                {/*Left Column*/}
                <div className={`border-r-2 border-dotted ${darkMode ? 'border-neutral-700' : ''} col-span-1`}>

                    {/*Header*/}
                    <div className={`relative border-b-2 p-2 border-dotted ${darkMode ? 'border-neutral-700' : ''} flex flex-col`}>
                        <h1 className={`tracking-widest font-semibold`}>Courses</h1>
                        <h1 className={`text-gray-500 text-xs`}>You may add more than 1 course!</h1>

                        <Button
                            // onClick={onUpdate}
                            onClick={() => setAdd(true)}
                            className={`absolute right-2 hover:text-green-600`}>
                            <PlusCircleIcon className={`size-5`}/>
                        </Button>
                    </div>

                    {/*Courses*/}
                    <div className={`h-[calc(100dvh-9.5rem)] rounded-lg scrollbar-none`}>
                        {courses.length === 0 ? (
                            // Display custom dialog if sprays array is empty
                            <div className="flex items-center justify-center h-full">
                                <div className="text-center">
                                    <RectangleGroupIcon className={`mx-auto size-12 text-gray-400`}/>
                                    <h3 className="mt-2 text-lg tracking-widest font-semibold">No Courses</h3>
                                    <p className="mt-1 text-sm tracking-tighter text-gray-500">Add a course into your account.</p>
                                    <div className="mt-6">
                                        <Button
                                            type="button"
                                            onClick={() => setAdd(true)}
                                            className="inline-flex items-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                        >
                                            <PlusIcon aria-hidden="true" className="-ml-0.5 mr-1.5 size-5"/>
                                            Add Course
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            // Display SprayCard components if sprays array is not empty
                            <div className="grid grid-cols-1 p-3 gap-3 auto-rows-auto">

                                {courses.map((course, index) => (
                                    <div
                                        key={index}
                                        onClick={() => handleViewCourse(course)}
                                        className={`cursor-pointer rounded-lg p-3 flex items-center ${
                                            selectedCourse?.name === course.name
                                                ? 'border-l-4 rounded-r-lg rounded-l-none bg-green-600/10 border-green-600'
                                                : darkMode
                                                    ? 'hover:bg-bgcard'
                                                    : 'hover:bg-bgcolorLight'
                                        }`}
                                    >
                                        <div className="tracking-widest">{course.name}</div>
                                        <div className="tracking-widest bg-green-600/25 border border-green-600 w-8 h-8 flex items-center justify-center rounded-lg ml-auto">
                                            {course.size}
                                        </div>
                                    </div>
                                ))}


                            </div>

                        )}

                    </div>


                </div>

                {/*Right Column*/}
                <div className={`col-span-3`}>

                    {selectedCourse ? (
                        <CourseExpanded
                            key={selectedCourse.id}
                            course={selectedCourse}
                            onUpdate={onUpdate}
                        />
                    ) : (
                        <div className="p-3 text-gray-400 italic">No course selected.</div>
                    )}

                </div>


            </div>


            <Dialog open={add} onClose={setAdd} className="relative z-50">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/50 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                />

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className={`relative transform overflow-hidden rounded-lg border ${darkMode ? 'bg-bgDark text-white border-neutral-700' : 'bg-white text-black'} px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-2xl sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
                        >
                            <div className="sm:flex sm:items-start">
                                <div
                                    className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-green-600/15 sm:mx-0 sm:size-10">
                                    <PlusCircleIcon aria-hidden="true" className="size-6 text-green-600"/>
                                </div>
                                <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                    <DialogTitle as="h3" className="text-base font-semibold">
                                        Add Course Information
                                    </DialogTitle>
                                    <div className="mt-2">
                                        <p className="text-sm text-gray-500">
                                            Adding your course helps improve analytics, optimize spray plans, and keeps
                                            all your course details in one place. This data powers our spray-building
                                            algorithm, giving you faster and more accurate results.
                                        </p>
                                    </div>
                                    <div className="w-full mt-6 grid grid-cols-4 gap-5">

                                        {/*Name*/}
                                        <div className="col-span-full relative flex items-center justify-center">
                                            <label
                                                className={`absolute ${darkMode ? 'bg-bgDark' : 'bg-white'} -top-2 left-2 inline-block rounded-lg px-1 text-xs font-medium`}
                                            >
                                                Course Name
                                            </label>
                                            <Input
                                                type="string"
                                                placeholder="Enter Course Name..."
                                                required
                                                value={courseName}
                                                onChange={(e) => setCourseName(e.target.value)}
                                                className={`block w-full ${darkMode ? 'bg-bgDark outline-neutral-700' : 'bg-white outline-gray-300'} rounded-md px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                            />
                                        </div>

                                        {/*Size*/}
                                        <div className="col-span-2 relative flex items-center justify-center">
                                            <label
                                                className={`absolute ${darkMode ? 'bg-bgDark' : 'bg-white'} -top-2 left-2 inline-block rounded-lg px-1 text-xs font-medium`}
                                            >
                                                Course Size
                                            </label>
                                            <Select
                                                placeholder="Enter Course Size..."
                                                required
                                                value={courseSize}
                                                onChange={(e) => setCourseSize(e.target.value)}
                                                className={`block w-full ${darkMode ? 'bg-bgDark outline-neutral-700' : 'bg-white outline-gray-300'} rounded-md px-3 py-2.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                            >
                                                <option value="">Select Course Size...</option>
                                                <option value="18">18 Hole Course</option>
                                                <option value="9">9 Hole Course</option>
                                            </Select>
                                        </div>

                                        {/*Total Acreage*/}
                                        <div className="col-span-2 relative flex items-center justify-center">
                                            <label
                                                className={`absolute ${darkMode ? 'bg-bgDark' : 'bg-white'} -top-2 left-2 inline-block rounded-lg px-1 text-xs font-medium`}
                                            >
                                                Total Acreage
                                            </label>
                                            <Input
                                                type="number"
                                                placeholder="Enter Total Acreage..."
                                                required
                                                value={courseAcreage}
                                                onChange={(e) => setCourseAcreage(e.target.value)}
                                                className={`block w-full ${darkMode ? 'bg-bgDark outline-neutral-700' : 'bg-white outline-gray-300'} rounded-md px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                            />
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                <Button
                                    type="button"
                                    onClick={handleAddCourse}
                                    // onClick={() => updateValues(chem.id, onSuccess)}
                                    className="inline-flex w-full justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-50 sm:ml-3 sm:w-auto"
                                >
                                    Add Course
                                </Button>
                                <Button
                                    type="button"
                                    onClick={() => setAdd(false)}
                                    className={`mt-3 inline-flex w-full justify-center rounded-md ${darkMode ? 'bg-bgpage' : 'bg-white ring-1 ring-inset ring-gray-300'} px-3 py-2 text-sm font-semibold shadow-sm hover:bg-opacity-50 sm:mt-0 sm:w-auto`}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </DialogPanel>
                    </div>
                </div>

            </Dialog>



        </div>
    );
};

export default CourseInfo;
